if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.isLoading = false;
      }

      hide(preventFocus = false) {
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (cart && this.openedBy) cart.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        if (this.isLoading) return;

        const spinner = opener.querySelector(".loading-overlay__spinner");
        this.isLoading = true;
        opener.setAttribute("aria-disabled", "true");
        opener.classList.add("loading");
        spinner?.classList.remove("hidden");

        fetch(opener.dataset.productUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

            if (!this.productElement) throw new Error("Product section was not found");

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            if (typeof window.trustspot_init === "function") window.trustspot_init();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.useCompactProductTitle();
            this.moveProductAccordionsToInfoColumn();
            this.preventVariantURLSwitching();
            opener.classList.remove("loading");
            spinner?.classList.add("hidden");
            super.show(opener);
          })
          .catch((error) => {
            console.error("Unable to open quick view.", error);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            spinner?.classList.add("hidden");
            this.isLoading = false;
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector("variant-radios, variant-selects");
        if (variantPicker) variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        this.productElement.querySelector("pickup-availability")?.remove();
        this.productElement.querySelector("product-modal")?.remove();
        this.productElement.querySelectorAll("modal-dialog").forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        const quickViewSectionId = `quick-view-${sectionId}-${this.dataset.sourceSection}-${this.dataset.productId}`;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          quickViewSectionId,
        );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((item) => item.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        if (!product?.classList.contains("product--columns")) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 400px, (min-width: 750px) calc((100vw - 8rem) / 2), calc(100vw - 7.2rem)";

        if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("400px", "360px");
        }

        mediaImages.forEach((image) => image.setAttribute("sizes", mediaImageSizes));
      }

      useCompactProductTitle() {
        const productTitle = this.modalContent.querySelector(".product__title > a h2");
        if (!productTitle) return;

        productTitle.classList.remove("h1");
        productTitle.classList.add("h2");
      }

      moveProductAccordionsToInfoColumn() {
        const accordionGroup = this.modalContent.querySelector(
          ".product__media-wrapper .product-acordion-group.small-hide",
        );
        const infoContainer = this.modalContent.querySelector(".product__info-container");
        if (!accordionGroup || !infoContainer) return;

        const viewDetails = infoContainer.querySelector(".product__view-details");
        infoContainer.insertBefore(accordionGroup, viewDetails);
      }
    },
  );
}

var externalQuickViewSelector = '#product-grid a[aria-controls^="quick__"]';

function removeExternalQuickViewControls(root) {
  if (!(root instanceof Element)) return;

  if (root.matches(externalQuickViewSelector)) root.remove();
  root.querySelectorAll(externalQuickViewSelector).forEach((control) => control.remove());
}

function guardNativeQuickViewControls() {
  const productGridContainer =
    document.getElementById("ProductGridContainer") || document.getElementById("product-grid");
  if (!productGridContainer || productGridContainer.dataset.nativeQuickViewGuard === "true") return;

  productGridContainer.dataset.nativeQuickViewGuard = "true";
  removeExternalQuickViewControls(productGridContainer);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => removeExternalQuickViewControls(node));
    });
  }).observe(productGridContainer, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", guardNativeQuickViewControls, { once: true });
} else {
  guardNativeQuickViewControls();
}
